import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import DashboardSocketBridge from '../DashboardSocketBridge';

export default function MainLayout() {
  const location = useLocation();
  const isLiveMap = location.pathname === '/live-map';

  return (
    <div className="flex h-screen bg-background dark:bg-background-dark overflow-hidden">
      <DashboardSocketBridge />
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden lg:ml-0">
        <Navbar />
        <main className="flex-1 overflow-y-auto p-4 lg:p-6 xl:p-8">
          <div className={isLiveMap ? 'w-full h-full' : 'max-w-7xl mx-auto h-full'}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
